export default __webpack_public_path__ + "static/media/Poppins-Black.eacee5bb.ttf";